import React from 'react';

import rateCards from '../../constants/businessUsersRateCards.json';
import userPage from '../../decorators/userPage';

class BusinessUserRateCardNotFound extends React.Component {
  componentDidMount() {
    const { userId } = this.props;
    const link = rateCards[userId];
    if (link) {
      window.location = link;
    }
  }

  render() {
    return (
      <div>
        Link to your rate card is not exist, please contact support to fix it.
      </div>
    );
  }
}

export default userPage(BusinessUserRateCardNotFound);
